var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 100 4"}},[_c('line',{attrs:{"x1":"0","y1":"2","x2":"100","y2":"2","stroke":_vm.color,"stroke-width":_vm.strokeWidth,"stroke-dasharray":_vm.dashArray,"stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }